import { Block } from './dynamic-artifact.schema';

export const ELUVE_POSTFIX = '_eluve';

export const addEluvePostfix = (blocks: Block[]) => {
  blocks.forEach((block, i) => {
    if (!block.key.includes(ELUVE_POSTFIX)) {
      block.key = `${block.key}${ELUVE_POSTFIX}${i}`;
    }
  });
};
